import React, { useState, useEffect } from 'react'
import { Switch, Button, Dropdown, message, Grid } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import styles from './style.module.scss'

const { useBreakpoint } = Grid

const NotificationMenu = ({ dispatch, user }) => {
  const [whatsApp, setWhatsApp] = useState(true)
  const [web, setWeb] = useState(true)
  const email = true // always enabled
  const screens = useBreakpoint()
  const [initialPrefs, setInitialPrefs] = useState({ whatsApp: true, web: true })

  // Load saved preferences from Redux
  useEffect(() => {
    // if (user?.notificationPreference) {

    const prefs = {
      whatsApp: user.notificationPreference?.whatsApp ?? false,
      web: user.notificationPreference?.web ?? false,
    }

    setWhatsApp(user.notificationPreference?.whatsApp ?? false)
    setWeb(user.notificationPreference?.web ?? false)
    setInitialPrefs(prefs)

    // }
  }, [user.notificationPreference])
  //   const [notification, setNotification] = useState < any > null

  const handleWhatsAppToggle = (val) => setWhatsApp(val)
  const handleWebToggle = (val) => setWeb(val)

  const handleSave = () => {
    const payload = {
      notificationPreference: {
        whatsApp,
        web,
        email, // always true
      },
    }

    // 🔑 Dispatch redux action that will call API (via saga/thunk)
    dispatch({
      type: 'user/Update_Profile',
      payload,
      resolve: () => {
        // message.success('Notification preferences saved!')
        setInitialPrefs({ whatsApp, web })
      },
      reject: () => {
        message.error('Failed to save preferences!')
      },
    })
  }

  const isChanged = whatsApp !== initialPrefs.whatsApp || web !== initialPrefs.web

  const menu = (
    <div
      className={styles.popup}
      style={{
        background: '#fff',
        padding: '1rem',
        // marginTop: {screens.md ? "90px":'40px'},
        // marginRight: 0,
        borderRadius: 8,
        width: 220,
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
      }}
    >
      <p style={{ marginBottom: 10, fontWeight: 600 }}>Notifications</p>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <span>WhatsApp</span>
        <Switch checked={whatsApp} onChange={handleWhatsAppToggle} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <span>Web</span>
        <Switch checked={web} onChange={handleWebToggle} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <span>Email</span>
        <Switch checked={email} disabled />
      </div>

      <Button type="primary" block onClick={handleSave} disabled={!isChanged}>
        Save
      </Button>
    </div>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']} placement={screens.md ? 'bottomRight' : 'bottom'}>
      <BellOutlined style={{ fontSize: 26, cursor: 'pointer' }} />
    </Dropdown>
  )
}

const mapStateToProps = ({ user }) => ({ user })

export default connect(mapStateToProps)(NotificationMenu)
